<div class="p-20 fx-row fx-wrap align-items-start justify-content-start text-center">
  <span class="title fx-flex-100 mb-10  text-center">{{title | translate}}</span>
  <div class="text fx-flex-100 text-center" [innerHTML]="text | translate"></div>
  <table mat-table [dataSource]="trademarks" style="z-index: 0;">
    <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns">
      <th mat-header-cell *matHeaderCellDef>
        <span class="upper small light bold">
          {{
          (column === 'line' ? 
          'TRADEMARK_DECLARE.LINE' : 
          'TRADEMARK_DECLARE.COLUMNS.' + column)
           | translate
          }}
        </span>
      </th>
      <td mat-cell *matCellDef="let trademark">
        <span class="text" [class.red]="!trademark[column]">{{(trademark[column] ||
          'TRADEMARK_DECLARE.ERROR_DIALOG_MISSING') | translate}}</span>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>
  <mat-divider class="fx-flex-100 mv-20"></mat-divider>
  <div class="fx-row align-items-center justify-content-center fx-flex-100">
    <button class="button fx-flex mr-10" (click)="onCancel()">{{'ACTIONS.CANCEL' | translate}}</button>
  </div>
</div>